import {
  FETCH_NAV,
  SET_NAV,
  UPDATE_NAV,
  NAV_SUCCESS,
  NAV_ERROR
} from './nav.type'
import ApiRest from '@/api/api-rest'
import { navigationBuilder } from '@/utilities/user/permission/ability'

const state = {
  navStatus: undefined,
  sidebarNav: []
}

const getters = {
  navStatus: state => state.navStatus,
  sidebarNav: state => state.sidebarNav
}

// Best Practice - updates state
const mutations = {
  [FETCH_NAV]: state => (state.navStatus = 'loading'),
  [NAV_SUCCESS]: state => (state.navStatus = 'saved'),
  [SET_NAV]: (state, resp) => {
    state.sidebarNav = resp
  },
  [NAV_ERROR]: (state, errMsg) => {
    state.navStatus = 'error'
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [FETCH_NAV]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit(FETCH_NAV)
      ApiRest()
        .get('/navigation-menu')
        // .get('static/json/navigation_tree.json')
        .then(({ data }) => {
          if (!data) {
            data = []
          }
          commit(SET_NAV, data)
          resolve(data)
        })
        .catch(errMsg => {
          commit(NAV_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [NAV_SUCCESS] (context) {
    context.commit(NAV_SUCCESS)
  },
  [NAV_ERROR] (context) {
    context.commit(NAV_ERROR)
  },
  [UPDATE_NAV] (context, permissions) {
    let nav = navigationBuilder(context.state.sidebarNav, permissions)
    context.commit(SET_NAV, nav)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/navigation/nav.module.js